import React from 'react';
import { texts } from 'utils/languages/fr';
import { InfoButton } from 'components';
import { Box, Typography } from '@mui/material';

const DefaultContent = props => {
    const { isCommercial, isPSI } = props;

    return (
        <React.Fragment>
            <Typography gutterBottom>{texts.DISTRIBUTOR_PEDAGOGIC_THANKS}</Typography>
            <br></br>
            <Typography gutterBottom>{texts.DISTRIBUTOR_PEDAGOGIC_PREPRARE(isPSI)}</Typography>
            <ul>
                {isCommercial && (
                    <li>
                        <Typography gutterBottom>
                            {isPSI ? texts.ACPR_NUMBER : texts.ORIAS_ATTESTATION}
                        </Typography>
                    </li>
                )}
                {isCommercial && (
                    <li>
                        <Typography gutterBottom>{texts.CRIMINAL_RECORD_EXTRACT}</Typography>
                    </li>
                )}
                <li>
                    <Typography gutterBottom>{texts.KBIS_SIMPLIFIED}</Typography>
                </li>
                <li>
                    <Typography gutterBottom>{texts.INSURANCE_CERTIFICATE}</Typography>
                </li>
                <li>
                    <Typography gutterBottom>{texts.SIGNATORY_ID}</Typography>
                </li>
                <li>
                    <Typography gutterBottom>{texts.DISTRIBUTOR_PEDAGOGIC_AFFIDAVIT}</Typography>
                </li>
                <li>
                    <Typography gutterBottom>{texts.VOS_COORDONNEES_BANCAIRES}</Typography>
                </li>
                <li>
                    <Box display="flex" flexWrap="nowrap" alignItems="center">
                        <Typography gutterBottom>{texts.LOGO_OPTIONAL}</Typography>
                        <InfoButton
                            disableMarginBottom
                            title={texts.DISTRIBUTOR_PEDAGOGIC_LOGO_INFO_TITLE}
                            content={texts.DISTRIBUTOR_PEDAGOGIC_LOGO_INFO_CONTENT}
                        />
                    </Box>
                </li>
            </ul>
            <br></br>
            {isCommercial ? (
                <Typography gutterBottom>
                    {texts.DISTRIBUTOR_PEDAGOGIC_OVERVIEW_COMMERCIAL}
                </Typography>
            ) : (
                <Typography gutterBottom>
                    {texts.DISTRIBUTOR_PEDAGOGIC_OVERVIEW_APPORTEUR}
                </Typography>
            )}
            <br></br>
            <Typography gutterBottom>{texts.DISTRIBUTOR_PEDAGOGIC_MAIL_FOR_SIGNATURE}</Typography>
            <br></br>
        </React.Fragment>
    );
};

export default DefaultContent;
